@if (previewPatrolReport) {
  <div
    class="d-flex gap-2 flex-grow-1 flex-xl-grow-0 justify-content-center justify-content-xl-end mb-3 report-preview"
  >
    <button
      [disabled]="!allowPDFExport"
      class="btn btn-lg d-flex gap-2 align-items-center btn-dark"
      (click)="
        previewPatrolReport = !previewPatrolReport; selectedEventData = null
      "
    >
      Back
    </button>

    <button
      [disabled]="!allowPDFExport"
      class="btn btn-danger btn-lg d-flex align-items-center gap-2"
      (click)="openTemplate(reportConfirmationTemplate)"
    >
      Get PDF Report <i class="fa-regular fa-file-pdf fs-4"></i>
    </button>
  </div>
  @if (previewReportData?.patrol_detail?.is_subcontracting) {
    <div
      class="report-preview p-2 border-primary text-primary border border-2 rounded my-2 text-center fw-semibold bg-white"
    >
      {{
        reportSiteClientLookup.client.data?.company_name ||
          reportSiteClientLookup.site.data?.company?.company_name
      }}
      is a Prime Contractor
    </div>
  }
  <div class="p-lg-5 p-2 report-preview shadow bg-white text-black">
    <div
      class="d-flex gap-3 gap-lg-5 border border-1 rounded mb-2 py-2 px-1 showHideControls flex-wrap"
    >
      <div class="fw-semibold small">Show/Hide</div>
      <div>
        <div
          (click)="
            previewReportDataAdditionalInfo.hide_header =
              !previewReportDataAdditionalInfo?.hide_header
          "
          role="button"
          [ngClass]="
            previewReportDataAdditionalInfo?.hide_header
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Header
        </div>
      </div>
      @if (!previewReportDataAdditionalInfo.hide_header) {
        <div>
          <div
            (click)="
              previewReportDataAdditionalInfo.hide_subscriber_header_details =
                !previewReportDataAdditionalInfo?.hide_subscriber_header_details
            "
            role="button"
            [ngClass]="
              previewReportDataAdditionalInfo?.hide_subscriber_header_details
                ? 'opacity-50'
                : 'text-primary'
            "
            class="small"
          >
            Company Address
          </div>
        </div>
      }
      @if (
        previewReportData?.patrol_detail?.address ||
        previewReportData?.patrol_detail?.custom_address
      ) {
        <div>
          <div
            (click)="
              previewReportDataAdditionalInfo.hide_client_detail =
                !previewReportDataAdditionalInfo?.hide_client_detail
            "
            role="button"
            [ngClass]="
              previewReportDataAdditionalInfo?.hide_client_detail
                ? 'opacity-50'
                : 'text-primary'
            "
            class="small"
          >
            {{
              reportSiteClientLookup.site.data?.id
                ? "Site Address"
                : "Client Address"
            }}
          </div>
        </div>
      }
    </div>

    @if (!previewReportDataAdditionalInfo?.hide_header) {
      <div class="header-container">
        <div class="subscriber_company_information_section">
          @if (
            !previewReportDataAdditionalInfo?.hide_subscriber_header_details
          ) {
            <div class="strong">
              {{ previewReportData?.patrol_detail?.subscriber_info?.name }}
            </div>
            <div>
              {{ previewReportData?.patrol_detail?.subscriber_info?.address }}
            </div>
            <div>
              {{ previewReportData?.patrol_detail?.subscriber_info?.city }}
            </div>
            @if (
              previewReportData?.patrol_detail?.subscriber_info?.mobile_number
            ) {
              <div>
                Ph:
                {{
                  previewReportData?.patrol_detail?.subscriber_info
                    ?.mobile_number
                }}
              </div>
            }
            <div>
              {{ previewReportData?.patrol_detail?.subscriber_info?.email }}
            </div>
          }
        </div>
        <div class="text-center">
          @if (previewReportData?.patrol_detail?.subscriber_info?.logo_url) {
            <img
              [ngClass]="largeView ? 'logo_img_large' : 'logo_img_mob'"
              alt="placeholder_logo"
              src="{{
                previewReportData?.patrol_detail?.subscriber_info?.logo_url
              }}"
            />
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-1 px-3 uploadLogo text-center"
            >
              Update Logo
            </div>
          } @else {
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-4 px-3 uploadLogo text-center ms-2"
            >
              Upload Logo
            </div>
          }
        </div>
      </div>
    }
    <div class="report-type-heading">Patrol Report</div>
    <!--CLIENT INFORMATION SECTION-->
    <div class="client_information_section">
      <div>
        {{ previewReportData?.patrol_detail?.client }}
      </div>
      @if (!previewReportDataAdditionalInfo?.hide_client_detail) {
        @if (previewReportData?.patrol_detail?.custom_address) {
          <div class="gt-multi-line">
            {{ previewReportData?.patrol_detail?.custom_address }}
          </div>
        }

        <div>
          {{ previewReportData?.patrol_detail?.address }}
        </div>

        <div>
          {{ previewReportData?.patrol_detail?.city }}
        </div>
      }
    </div>
    <div class="patrol-table mt-5">
      @if (
        previewReportData?.patrol_detail?.time_zone &&
        previewReportData?.patrol_detail?.time_zone_diff
      ) {
        <div
          style="
            font-size: 10px;
            padding-bottom: 0.5rem;
            color: #333;
            font-weight: bold;
            font-style: italic;
          "
        >
          Timestamps shown in
          {{ previewReportData?.patrol_detail?.time_zone }}
          {{ previewReportData?.patrol_detail?.time_zone_diff }}
        </div>
      }
      <!--PATROL TABLE SECTION-->
      @if (previewReportData?.patrol_detail?.report_date) {
        <div style="font-size: 10px; padding-bottom: 0.5rem">
          <div>
            Report Generated
            {{ previewReportData?.patrol_detail?.report_date }}
          </div>
          @if (selectedDateRange.start && selectedDateRange.end) {
            <div>
              Showing Records Between
              {{ selectedDateRange.start | date: "dd MMM yyyy HH:mm" }}
              to
              {{ selectedDateRange.end | date: "dd MMM yyyy HH:mm" }}
            </div>
          }
        </div>
      }
    </div>
    @if (totalRows) {
      <div class="mt-2">
        <gtapp-pagination-control
          [pageSize]="pageSize"
          [pageNum]="pageNum"
          [previous]="previous"
          [totalRows]="totalRows"
          (onChangePagination)="onPaginationChange($event)"
        >
        </gtapp-pagination-control>
      </div>
    }
    <div class="mb-3 border border-1 rounded p-1">
      <div class="fw-semibold small px-2">Show/Hide</div>
      <div class="d-flex gap-3 gap-lg-5 px-2 py-2 showHideControls flex-wrap">
        <div
          (click)="
            previewReportDataAdditionalInfo.hide_uploads =
              !previewReportDataAdditionalInfo?.hide_uploads;
            filterSummaryData()
          "
          role="button"
          [ngClass]="
            previewReportDataAdditionalInfo?.hide_uploads
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Photo Events
        </div>
        <div>
          <div
            (click)="
              previewReportDataAdditionalInfo.hide_guard_column =
                !previewReportDataAdditionalInfo?.hide_guard_column
            "
            role="button"
            [ngClass]="
              previewReportDataAdditionalInfo?.hide_guard_column
                ? 'opacity-50'
                : 'text-primary'
            "
            class="small"
          >
            Guard Names
          </div>
        </div>
        <div>
          <div
            (click)="
              showDataObject.showSummaryOnly = !showDataObject.showSummaryOnly;
              showDataObject.showCheckpointScanLocation = false
            "
            role="button"
            [ngClass]="
              !showDataObject.showSummaryOnly ? 'opacity-50' : 'text-primary'
            "
            class="small"
          >
            Summary Only
          </div>
        </div>
        @if (checkpointStats.hasQrNFCCheckpointScans) {
          <div>
            <div
              (click)="
                showDataObject.showCheckpointScanLocation =
                  !showDataObject.showCheckpointScanLocation;
                showDataObject.showSummaryOnly = false
              "
              role="button"
              [ngClass]="
                !showDataObject.showCheckpointScanLocation
                  ? 'opacity-50'
                  : 'text-primary'
              "
              class="small"
            >
              Scan Locations (QR/NFC)
            </div>
          </div>
        }
      </div>
    </div>
    @if (previewReportSummaryData?.length) {
      @if (largeView) {
        <div class="patrol-table mb-5">
          <table class="w-100">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Time</th>
                <th>Event Type</th>
                <th style="border-left: hidden"></th>
                @if (!previewReportDataAdditionalInfo?.hide_guard_column) {
                  <th>Guard</th>
                }
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (
                row of previewReportSummaryData;
                track row;
                let i = $index
              ) {
                <tr id="section_up{{ i + 1 }}">
                  <td [class.opacity-25]="row?.is_deleted" class="text-center">
                    {{ i + 1 + previous }}
                  </td>
                  <td [class.opacity-25]="row?.is_deleted">
                    <div class="d-flex gap-2">
                      {{
                        row?.updated_at
                          | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                      }}

                      <div
                        class="edit-button m-0"
                        (click)="
                          editEventTimeStamp(
                            row,
                            eventTimepStampUpdateTemplateRef
                          )
                        "
                      ></div>
                    </div>
                  </td>
                  <td
                    [class.opacity-25]="row?.is_deleted"
                    class="uppercase line-height"
                  >
                    @if (
                      row?.file_url ||
                      ([6, 12].includes(row?.event_action) &&
                        row?.event_type == "Patrol Update" &&
                        showDataObject.showCheckpointScanLocation)
                    ) {
                      <a
                        class="cursor-pointer"
                        (click)="
                          scrollToSection($event, 'section_down' + (i + 1))
                        "
                        style="color: #00538d"
                      >
                        {{ row?.pdf_action_label }}
                      </a>
                    } @else {
                      {{ row?.pdf_action_label }}
                    }
                  </td>
                  <td
                    [class.opacity-25]="row?.is_deleted"
                    style="border-left: hidden"
                  >
                    <div class="d-flex">
                      <div>
                        <div class="gt-multi-line line-height fs-6">
                          {{ row?.detail }}
                        </div>
                        @if (row?.prompts?.length) {
                          @for (item of row?.prompts; track item) {
                            <div class="mb-2">
                              @for (dataItem of item?.data; track dataItem) {
                                @if (dataItem?.show_in_reports) {
                                  <div>
                                    <ng-template
                                      *ngTemplateOutlet="
                                        promptTemplate;
                                        context: { value: dataItem }
                                      "
                                    ></ng-template>
                                  </div>
                                }
                              }
                            </div>
                          }
                        }
                      </div>
                      @if (
                        (row?.event_type == "Patrol Update"
                          ? [1, 2, 7]
                          : [7, 8, 19]
                        ).includes(row?.event_action)
                      ) {
                        <div
                          (click)="
                            openCommentTemplate(editCommentTemplate, row)
                          "
                        >
                          @if (row?.detail) {
                            <span class="edit-button mx-2"> </span>
                          } @else {
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </td>
                  @if (!previewReportDataAdditionalInfo?.hide_guard_column) {
                    <td [class.opacity-25]="row?.is_deleted">
                      {{ row?.user_name }}
                    </td>
                  }
                  <td>
                    @if (
                      (row?.event_type == "Patrol Update"
                        ? [1, 2, 7]
                        : [7, 8, 19]
                      ).includes(row?.event_action)
                    ) {
                      <div
                        class="ms-1"
                        (click)="
                          deleteRestoreUserUpdate({
                            event: row,
                            type: row?.is_deleted ? 'restore' : 'delete',
                          })
                        "
                      >
                        @if (row?.is_deleted) {
                          <span>
                            <i
                              class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                            ></i>
                          </span>
                        } @else {
                          <span>
                            <i
                              class="fs-5 fa-solid fa-circle-minus text-danger"
                            ></i>
                          </span>
                        }
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mb-5">
          <tbody>
            @for (row of previewReportSummaryData; track row; let i = $index) {
              <tr id="section_up{{ i + 1 }}">
                <td class="bg-light text-dark">
                  <div class="d-flex justify-content-between">
                    <div
                      class="line-height small text-secondary d-flex gap-1"
                      [class.opacity-25]="row?.is_deleted"
                    >
                      {{
                        row?.updated_at
                          | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                      }}
                      <span
                        (click)="
                          editEventTimeStamp(
                            row,
                            eventTimepStampUpdateTemplateRef
                          )
                        "
                        class="edit-button ms-2"
                      ></span>
                    </div>
                    @if (
                      (row?.event_type == "Patrol Update"
                        ? [1, 2, 7]
                        : [7, 8, 19]
                      ).includes(row?.event_action)
                    ) {
                      <div
                        class="ms-1"
                        (click)="
                          deleteRestoreUserUpdate({
                            event: row,
                            type: row?.is_deleted ? 'restore' : 'delete',
                          })
                        "
                      >
                        @if (row?.is_deleted) {
                          <span>
                            <i
                              class="fa-2x fa-solid fa-trash-can-arrow-up text-secondary"
                            ></i>
                          </span>
                        } @else {
                          <span>
                            <i
                              class="fs-5 fa-solid fa-circle-minus text-danger"
                            ></i>
                          </span>
                        }
                      </div>
                    }
                  </div>
                  <div
                    class="d-flex justify-content-between small text-secondary"
                  >
                    <div
                      [class.opacity-25]="row?.is_deleted"
                      class="uppercase line-height"
                    >
                      @if (
                        row?.file_url ||
                        ([6, 12].includes(row?.event_action) &&
                          row?.event_type == "Patrol Update" &&
                          showDataObject.showCheckpointScanLocation)
                      ) {
                        <a
                          class="cursor-pointer"
                          (click)="
                            scrollToSection($event, 'section_down' + (i + 1))
                          "
                          style="color: #00538d"
                        >
                          {{ row?.pdf_action_label }}
                        </a>
                      } @else {
                        {{ row?.pdf_action_label }}
                      }
                    </div>
                    @if (!previewReportDataAdditionalInfo?.hide_guard_column) {
                      <div [class.opacity-25]="row?.is_deleted">
                        {{ row?.user_name }}
                      </div>
                    }
                  </div>
                  <div [class.opacity-25]="row?.is_deleted">
                    <div class="d-flex pt-2">
                      <pre class="multi-line line-height fs-6">{{
                        row?.detail
                      }}</pre>
                      @if (
                        (row?.event_type == "Patrol Update"
                          ? [1, 2, 7]
                          : [7, 8, 19]
                        ).includes(row?.event_action)
                      ) {
                        <div
                          (click)="
                            openCommentTemplate(editCommentTemplate, row)
                          "
                        >
                          @if (row?.detail) {
                            <span class="edit-button mx-2"> </span>
                          } @else {
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }

    <!-- DETAILS SECTION -->
    @if (!showDataObject.showSummaryOnly) {
      <div class="mb-5">
        @for (
          item of patrolReportDataListPaginatedDict?.[pageNum];
          track item;
          let i = $index
        ) {
          @if (
            item?.file_url ||
            ([6, 12].includes(item?.event_action) &&
              item?.event_type == "Patrol Update" &&
              showDataObject.showCheckpointScanLocation &&
              !item?.is_deleted)
          ) {
            <div id="section_down{{ i + 1 }}">
              @if (item?.file_url) {
                <ng-container>
                  <div class="d-flex mb-2">
                    <div
                      [ngClass]="
                        largeView
                          ? 'w-25 small pe-1 pb-3'
                          : 'w-50 small pe-1 pb-3'
                      "
                    >
                      @if (item?.download_url) {
                        <a
                          href="{{ item.download_url }}"
                          style="text-decoration: none"
                        >
                          <button class="btn btn-primary btn-sm mb-3">
                            Download Video
                          </button>
                        </a>
                      }
                      <!--TIMESTAMP-->
                      <div
                        style="font-weight: 600"
                        class="key-value d-flex gap-1 align-items-center"
                      >
                        {{
                          item?.updated_at
                            | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                        }}
                        <span
                          class="edit-button mx-2"
                          (click)="
                            editEventTimeStamp(
                              item,
                              eventTimepStampUpdateTemplateRef
                            )
                          "
                        ></span>
                        @if (
                          (item?.event_type == "Patrol Update"
                            ? [1, 2, 7]
                            : [7, 8, 19]
                          ).includes(item?.event_action)
                        ) {
                          <span
                            class="ms-1"
                            (click)="
                              deleteRestoreUserUpdate({
                                event: item,
                                type: item?.is_deleted ? 'restore' : 'delete',
                              })
                            "
                          >
                            @if (item?.is_deleted) {
                              <span>
                                <i
                                  class="fa-solid fa-trash-can-arrow-up fa-2x text-secondary"
                                ></i>
                              </span>
                            } @else {
                              <span>
                                <i
                                  class="fa-solid fa-circle-minus text-danger fs-4"
                                ></i>
                              </span>
                            }
                          </span>
                        }
                      </div>
                      <!-- GPS ACCURACY NOTIFICATION-->
                      @if (item?.gps?.source) {
                        <div class="warning distance">
                          @if (item?.gps?.source == 1) {
                            Location may not be accurate.
                          } @else if (item?.gps?.source == 2) {
                            Location is an approximation only.
                          }
                        </div>
                      }
                      <!--SECTION: EVENT LOCATION-->
                      @if (item?.gps?.lat && item?.gps?.lon) {
                        <div style="margin-bottom: 2rem">
                          <div class="key-label text-secondary">
                            Event Location
                          </div>
                          <div
                            style="
                              max-width: 100%;
                              height: 150px;
                              object-fit: none;
                            "
                            class="small"
                          >
                            <gtapp-map-leaflet
                              [customMapConfig]="{
                                showSimpleStaticMap: true,
                              }"
                              [latLon]="{
                                markerTooltip: item?.event_by,
                                lat: item?.gps?.lat,
                                lon: item?.gps?.lon,
                              }"
                              [mapId]="'map_' + i"
                            ></gtapp-map-leaflet>
                          </div>
                        </div>
                      }
                      <!--SECTION:  PHOTO COMMENT/NOTES-->
                      <div class="d-inline">
                        <div class="gt-multi-line">
                          @if (item?.detail) {
                            <span>
                              {{ item?.detail }}
                            </span>
                          }
                          @if (
                            (item?.event_type == "Patrol Update"
                              ? [1, 2, 7]
                              : [7, 8, 19]
                            ).includes(item?.event_action)
                          ) {
                            <span class="ms-auto">
                              @if (item?.detail) {
                                <span
                                  class="edit-button mx-2"
                                  (click)="
                                    openCommentTemplate(
                                      editCommentTemplate,
                                      item
                                    )
                                  "
                                >
                                </span>
                                <span (click)="deleteComment(item)">
                                  <i
                                    class="fa-solid fa-circle-minus text-danger fs-4"
                                  ></i>
                                </span>
                              } @else {
                                <div
                                  class="pt-2"
                                  (click)="
                                    openCommentTemplate(
                                      editCommentTemplate,
                                      item
                                    )
                                  "
                                >
                                  <button class="btn btn-secondary btn-sm">
                                    Add Remarks
                                  </button>
                                </div>
                              }
                            </span>
                          }
                        </div>
                      </div>
                    </div>

                    <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                      @if (
                        [".mp4", ".mov", ".webm", ".mkv"].includes(
                          item?.file_extension
                        )
                      ) {
                        <video
                          controls
                          style="
                            max-height: 100%;
                            max-width: 100%;
                            display: flex;
                            width: 100%;
                          "
                        >
                          <source src="{{ item?.file_url }}" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      } @else {
                        <img
                          (click)="onOpenImage($event, item)"
                          src="{{ item?.file_url }}"
                          style="
                            max-height: 100%;
                            max-width: 100%;
                            display: flex;
                          "
                        />
                      }
                    </div>
                  </div>
                </ng-container>
              } @else {
                <ng-container>
                  <div class="row row-cols-2">
                    <div class="col">
                      <div class="row row-col-1row-col-lg-2">
                        <div class="col">
                          <div
                            style="font-weight: 600"
                            class="key-value d-flex gap-1"
                          >
                            {{
                              item?.updated_at
                                | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                            }}
                          </div>
                          <!-- GPS ACCURACY NOTIFICATION-->
                          @if (item?.gps?.source) {
                            <div class="warning distance">
                              @if (item?.gps?.source == 1) {
                                Location may not be accurate.
                              } @else if (item?.gps?.source == 2) {
                                Location is an approximation only.
                              }
                            </div>
                          }
                        </div>
                        <div class="col">
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 0.75rem;
                              margin-bottom: 0.5rem;
                            "
                          >
                            <span class="uppercase key-value">{{
                              item?.pdf_action_label
                            }}</span>
                            <div style="display: flex !important">
                              @if (item?.event_action == 12) {
                                <img
                                  src="https://app.guardtracker.com.au/assets/images/NFC_logo.avif"
                                  alt="NFC Logo"
                                  width="20"
                                  height="20"
                                  style="
                                    width: 20px !important;
                                    height: 20px !important;
                                    margin-right: 5px !important;
                                  "
                                />
                              }
                              @if (item?.event_action == 6) {
                                <img
                                  src="https://app.guardtracker.com.au/assets/images/qr-code-logo.avif"
                                  alt="QR Logo"
                                  width="20"
                                  height="20"
                                  style="
                                    width: 20px !important;
                                    height: 20px !important;
                                    margin-right: 5px !important;
                                  "
                                />
                              }
                            </div>
                          </div>
                          <div class="gt-multi-line">
                            {{ item.detail }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      @if (item?.gps?.lat && item?.gps?.lon) {
                        <div style="margin-bottom: 2rem">
                          <div class="key-label text-secondary">
                            Event Location
                          </div>
                          <div
                            style="
                              max-width: 100%;
                              height: 150px;
                              object-fit: none;
                            "
                            class="small"
                          >
                            <gtapp-map-leaflet
                              [customMapConfig]="{
                                showSimpleStaticMap: true,
                              }"
                              [latLon]="{
                                markerTooltip: item?.event_by,
                                lat: item?.gps?.lat,
                                lon: item?.gps?.lon,
                              }"
                              [mapId]="'map_' + i"
                            ></gtapp-map-leaflet>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <!--OTHER EVENTS THAT HAVE LOCATION (QR & NFC)-->
                </ng-container>
              }
            </div>
          }
        }
      </div>
    }
    @if (promptFileDataUrls?.length && !showDataObject.showSummaryOnly) {
      @for (promptFile of promptFileDataUrls; track $index) {
        <div [id]="'mobile_form_detail' + promptFile?.file_id">
          <ng-container>
            <div class="d-flex mb-2">
              <div
                [ngClass]="
                  largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                "
              >
                <!--SECTION:  PHOTO COMMENT/NOTES-->
                <div class="d-inline">
                  <div
                    style="color: #00538d"
                    class="gt-multi-line cursor-pointer text-decoration-underline"
                    (click)="
                      scrollToSection(
                        $event,
                        'mobile_form_summary' + promptFile?.file_id
                      )
                    "
                  >
                    @if (promptFile?.description) {
                      <span>
                        {{ promptFile?.description }}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                @if (
                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                    promptFile?.file_extension
                  )
                ) {
                  <video autoplay>
                    <source src="{{ promptFile?.file_url }}" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                } @else {
                  <img
                    (click)="onOpenImage($event, promptFile)"
                    src="{{ promptFile?.file_url }}"
                    style="max-height: 100%; max-width: 100%; display: flex"
                  />
                }
              </div>
            </div>
          </ng-container>
        </div>
      }
    }
  </div>
} @else {
  <div class="d-flex gap-3 align-items-center px-2 flex-wrap mb-3">
    <div class="d-flex gap-1 align-items-center">
      @if (reportSiteClientLookup.site.data?.id) {
        <dt>Site</dt>
        <dd
          class="bg-primary text-white rounded p-1 px-2"
          role="button"
          (click)="openFilterDialog()"
        >
          {{ reportSiteClientLookup.site.data?.company_name }}

          @if (reportSiteClientLookup.site.data?.company?.company_name) {
            <span>
              [{{ reportSiteClientLookup.site.data?.company?.company_name }}]
            </span>
          }
        </dd>
      } @else {
        <dt>Client</dt>
        <dd
          class="bg-primary text-white rounded p-1 px-2"
          role="button"
          (click)="openFilterDialog()"
        >
          {{ reportSiteClientLookup.client.data?.company_name }}
        </dd>
      }
    </div>
    <div class="d-flex gap-1 align-items-center">
      <dt>Time</dt>
      <dd
        class="bg-primary text-white rounded p-1 px-2"
        role="button"
        (click)="openFilterDialog()"
      >
        {{ selectedDateRange.start | customDate: "d MMM y HH:mm" }} -
        {{ selectedDateRange.end | customDate: "d MMM y HH:mm" }}
      </dd>
    </div>
    <!-- <div class="d-flex gap-1 align-items-center">
      <dt>Report</dt>
      <dd
        class="bg-primary text-white rounded p-1 px-2"
        role="button"
        (click)="openFilterDialog()"
      >
        @if (selectedReportUpdatesToFetch.has(1)) {
          Patrol Updates
        }
        @if (selectedReportUpdatesToFetch.has(2)) {
          @if (selectedReportUpdatesToFetch.has(1)) {
            ,
          }
          Job Updates
        }
      </dd>
    </div> -->
    @if (selectedUserData?.id) {
      <div class="d-flex gap-1 align-items-center">
        <dt>User</dt>
        <dd
          class="bg-primary text-white rounded p-1 px-2"
          role="button"
          (click)="openFilterDialog()"
        >
          {{ selectedUserData?.full_name }}
        </dd>
      </div>
    }

    @if (patrolReportDataListPaginatedDict?.[pageNum]?.length) {
      <div
        class="d-flex gap-2 flex-grow-1 flex-xl-grow-0 justify-content-center justify-content-xl-center"
      >
        @if (!previewPatrolReport && checkpointStats.hasCheckpointScans) {
          <button
            [disabled]="!allowPDFExport"
            class="btn btn-success btn-lg d-flex align-items-center gap-2"
            (click)="openTemplate(reportConfirmationTemplate, 'xlRecipients')"
          >
            <i class="fa-regular fa-file-excel fs-4"></i>
          </button>
        }
        @if (!previewPatrolReport) {
          <button
            [disabled]="!allowPDFExport"
            class="btn btn-lg d-flex gap-2 align-items-center btn-danger"
            (click)="getPatrolPreviewDetails()"
          >
            <i class="fa-regular fa-file-pdf fs-4"></i>
          </button>
        }
      </div>
    }
  </div>

  @if (largeView) {
    <gtapp-gt-custom-table
      [deskTopTableData]="patrolReportDataListPaginatedDict?.[pageNum]"
      [desktopTableDetails]="patrolReportLogDetailsTableView"
      [tableStyle]="tableStyle"
      [otherParams]="otherParams"
      (rowClick)="onTableRowClick($event)"
      (sortColumn)="sortColumn($event)"
      (paginationChange)="onPaginationChange($event)"
    ></gtapp-gt-custom-table>
  } @else {
    @if (!selectedEventData) {
      <gtapp-card-list
        [mobileCardBackendData]="patrolReportDataListPaginatedDict?.[pageNum]"
        [mobileCardDetails]="patrolReportLogDetailsMobileView"
        (rowClick)="onTableRowClick($event)"
        (sortColumn)="sortColumn($event)"
        [otherParams]="otherParams"
        (paginationChange)="onPaginationChange($event)"
      ></gtapp-card-list>
    }
  }
  @if (selectedEventData) {
    <gtapp-selected-event-detail
      [selectedEvent]="selectedEventData"
      selectedEventFrom="user_update_history"
      [userEventDetailsTableView]="
        patrolReportLogDetailsTableView?.concat([
          {
            header: 'User',
            name: 'user_name',
          },
        ])
      "
      [extraCheck]="true"
      (goBack)="hideDetails()"
    ></gtapp-selected-event-detail>
  }
}
<ng-template #patrolFilterTemplate let-patrolFilterTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">Report</div>

    <div class="d-flex flex-wrap gap-4 mb-3">
      <ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
      <!-- <div>
        <dt>Report Type</dt>
        <div class="d-flex flex-wrap gap-3">
          <label for="patrolUpdates">
            <input
              class="form-check-input"
              type="checkbox"
              id="patrolUpdates"
              [checked]="selectedReportUpdatesToFetch.has(1)"
              (change)="
                onDateTimeCheck();
                selectedReportUpdatesToFetch.has(1)
                  ? selectedReportUpdatesToFetch.delete(1)
                  : selectedReportUpdatesToFetch.add(1)
              "
            />
            Patrol Updates</label
          >

          <label for="jobUpdates">
            <input
              class="form-check-input"
              type="checkbox"
              id="jobUpdates"
              [checked]="selectedReportUpdatesToFetch.has(2)"
              (change)="
                onDateTimeCheck();
                selectedReportUpdatesToFetch.has(2)
                  ? selectedReportUpdatesToFetch.delete(2)
                  : selectedReportUpdatesToFetch.add(2)
              "
            />
            Job Updates</label
          >
        </div>
      </div> -->

      <div>
        <div class="small mx-2">Time of day presets</div>
        <div class="d-flex gap-2 my-2">
          @for (time of timeSelectValues; track time) {
            <div>
              <button
                class="btn btn-outline-primary"
                (click)="updateTime(time)"
              >
                {{ time?.value }}
              </button>
            </div>
          }
        </div>

        <div class="row row-cols-auto g-3 mb-2">
          <div class="form-floating">
            <input
              id="startDay"
              class="form-control"
              type="datetime-local"
              placeholder="Pick Date & Time"
              [(ngModel)]="selectedDateRange.start"
              (change)="onDateTimeCheck()"
            /><label for="startDay"> Start</label>
          </div>

          <div class="form-floating">
            <input
              id="endDay"
              type="datetime-local"
              class="form-control"
              placeholder="Pick Date & Time"
              [(ngModel)]="selectedDateRange.end"
              [disabled]="!selectedDateRange.start"
              [min]="selectedDateRange.start"
              (change)="onDateTimeCheck()"
            /><label for="endDay"> End</label>
          </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          @for (date of dateSelectValues; track date) {
            <div>
              <button
                class="btn btn-outline-primary"
                (click)="updateDate(date?.key)"
              >
                {{ date?.value }}
              </button>
            </div>
          }
        </div>
      </div>
      <!-- <div>
        @if (selectedUserData?.id) {
          <dl class="px-2 px-md-4">
            <dt>User</dt>
            <dd (click)="editField('user')" class="link-edit">
              {{ selectedUserData?.full_name }}
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="userDropDownList"
            placeHolder="Assignee"
            searchKeyword="full_name"
            [itemTemplate]="userFilterTemplate"
            inputId="userLookupFilterInputId"
            (inputChanged)="onUserSearch($event)"
            (selected)="onUserSelect($event)"
            (fieldCleared)="editField('user')"
            (inputFocused)="editField('user')"
          >
          </gtapp-auto-complete>
          <ng-template #userFilterTemplate let-item>
            <div
              class="d-flex gap-2 flex-wrap justify-content-between align-items-start"
            >
              <div class="d-flex gap-2 flex-wrap align-items-start">
                <span>
                  {{ item?.full_name }}
                </span>
                @if (item?.access_status === 2) {
                  <div
                    class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                  >
                    Casual
                  </div>
                }
              </div>
            </div>

            @if (item?.subcontractors?.length) {
              <div class="small text-secondary">
                🟧Subcontractor:
                <span class="subcontractor-name">{{
                  item?.subcontractors
                }}</span>
              </div>
            }
          </ng-template>
        }
      </div> -->
    </div>

    @if (filterErrorMessage) {
      <div class="alert alert-warning">
        {{ filterErrorMessage }}
      </div>
    }
    <div class="d-flex gap-2 pt-3">
      <button
        class="btn btn-dark btn-lg w-100"
        (click)="patrolFilterTemplateRef.close(false)"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary btn-lg w-100"
        [disabled]="
          filterErrorMessage ||
          !(
            reportSiteClientLookup.site.data?.id ||
            reportSiteClientLookup.client.data?.id
          )
        "
        (click)="patrolFilterTemplateRef.close(true)"
      >
        Apply
      </button>
    </div>
  </div>
</ng-template>

<ng-template #siteClientLookup let-siteClientLookupTempRef="dialogRef">
  <div class="d-flex flex-wrap gap-3 align-start">
    <div class="flex-grow-1 flex-xl-grow-0">
      <div [class.opacity-50]="reportSiteClientLookup.site.disabled">
        @if (reportSiteClientLookup.site.data?.id) {
          <dl class="px-2 px-md-4">
            <dt>Site</dt>
            <dd (click)="editField('site')" class="link-edit">
              {{ reportSiteClientLookup.site.data?.company_name }}

              @if (reportSiteClientLookup.site.data?.company?.company_name) {
                <span>
                  [{{
                    reportSiteClientLookup.site.data?.company?.company_name
                  }}]
                </span>
              }
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="siteDropDownList"
            placeHolder="Select Site"
            searchKeyword="company_name"
            [initialValue]="reportSiteClientLookup.site.data?.company_name"
            [itemTemplate]="siteTemplate"
            (inputChanged)="onSiteSearch($event)"
            (selected)="onSelectSite($event)"
            inputId="siteLookupFilterInputId"
            [enableCloseOption]="true"
            (fieldCleared)="editField('site')"
            (inputFocused)="inputFocused('site')"
          >
          </gtapp-auto-complete>

          <ng-template #siteTemplate let-item>
            <div class="fw-medium">
              {{ item?.company_name }} [{{ item?.company?.company_name }}]
            </div>
            <div class="small-font text-secondary">
              {{ item?.address?.full_address }}
            </div>
          </ng-template>
        }
      </div>
    </div>
    <div class="flex-grow-1 flex-xl-grow-0">
      <div [class.opacity-50]="reportSiteClientLookup.client.disabled">
        @if (reportSiteClientLookup.client.data?.id) {
          <dl class="px-2 px-md-4">
            <dt>Client</dt>
            <dd (click)="editField('client')" class="link-edit">
              {{ reportSiteClientLookup.client.data?.company_name }}
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="clientDropDownList"
            placeHolder="Select Client"
            searchKeyword="company_name"
            [itemTemplate]="clientTemplate"
            (inputChanged)="onClientSearch($event)"
            [initialValue]="reportSiteClientLookup.client.data?.company_name"
            (selected)="onClientSelect($event)"
            [enableCloseOption]="true"
            inputId="clientLookupFilterInputId"
            (fieldCleared)="editField('client')"
            (inputFocused)="inputFocused('client')"
          >
          </gtapp-auto-complete>

          <ng-template #clientTemplate let-item>
            <div>
              {{ item?.company_name }}
            </div>
          </ng-template>
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- send report confirmation  DIALOG -->
<ng-template
  #reportConfirmationTemplate
  let-reportConfirmationTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Recipients
      <span class="float-end" (click)="reportConfirmationTemplateRef.close()">
        <i class="fa-2x fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="d-flex gap-3 align-items-center flex-wrap mb-4">
      <button
        class="btn btn-sm btn-outline-primary"
        (click)="
          navigateToSiteClient(
            reportSiteClientLookup.site.data?.id ? 'site' : 'client',
            reportSiteClientLookup.site.data?.id ||
              reportSiteClientLookup.client.data?.id
          )
        "
      >
        Edit Recipients
      </button>
      @if (data?.source === "pdfRecipients") {
        <div>
          <label for="summaryOnlyField">
            <input
              class="form-check-input"
              type="checkbox"
              id="summaryOnlyField"
              [checked]="showDataObject.showSummaryOnly"
              (change)="
                showDataObject.showSummaryOnly =
                  !showDataObject.showSummaryOnly;
                showDataObject.showCheckpointScanLocation = false
              "
            />
            Show Summary Only</label
          >
        </div>
        @if (checkpointStats.hasQrNFCCheckpointScans) {
          <div class="col">
            <label for="checkPointLocationShow">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkPointLocationShow"
                [checked]="showDataObject.showCheckpointScanLocation"
                (change)="
                  showDataObject.showCheckpointScanLocation =
                    !showDataObject.showCheckpointScanLocation;
                  showDataObject.showSummaryOnly = false
                "
              />
              Show Scan Locations (QR/NFC)</label
            >
          </div>
        }
      }
    </div>

    @if (reportRecipientListData?.length) {
      <div class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3">
        @if (reportRecipientListData?.length > 1) {
          <div class="col-12 col-lg-12 col-xxl-12 text-primary form-check mb-3">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="
                selectedReportRecipientsListData?.length ===
                reportRecipientListData?.length
              "
              (change)="selectAllContacts($event)"
              id="selectAllBox"
            />
            <label for="selectAllBox"
              >Select All [{{ reportRecipientListData?.length }}]</label
            >
          </div>
        }
        @for (
          contact of reportRecipientListData;
          track contact;
          let i = $index
        ) {
          <div class="col form-check">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="!contact.isSnubbed"
              (change)="selectUnselectRecipients(contact)"
              id="check-{{ contact.id }}-{{ i }}"
            />
            <label
              class="form-check-label"
              for="check-{{ contact.id }}-{{ i }}"
            >
              {{ contact?.user_full_name }}

              <div class="small-font">
                {{ contact?.user_email }}
              </div>
            </label>
          </div>
        }
      </div>
    } @else {
      <div class="mb-2 alert alert-danger">
        There are no recipients configured for this site
      </div>
    }
    @if (selectedReportRecipientsListData?.length) {
      <dt class="text-end me-4 pt-2">
        Total Recipients Selected:
        <span class="fw-semibold fs-6">{{
          selectedReportRecipientsListData?.length
        }}</span>
      </dt>
    }

    <div class="row row-cols-2 pt-4">
      <div class="col">
        <button
          class="btn btn-lg btn-secondary w-100"
          type="button"
          (click)="reportConfirmationTemplateRef.close()"
        >
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          type="button"
          (click)="
            exportData(data?.source === 'pdfRecipients' ? 'pdf' : 'xlsx');
            reportConfirmationTemplateRef.close()
          "
          [disabled]="!selectedReportRecipientsListData?.length"
        >
          Send {{ data?.source === "pdfRecipients" ? "PDF" : "XLSX" }} Report
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #eventTimepStampUpdateTemplateRef
  let-eventTimepStampUpdateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update {{ data.name }} Time
      <span
        class="float-end"
        (click)="eventTimepStampUpdateTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data?.minDateTime || data?.maxDateTime) {
      <div class="small border border-1 text-secondary p-2 mb-2 rounded-2">
        {{ data.name }} time must be
        @if (data?.minDateTime && data?.maxDateTime) {
          between {{ data?.minDateTime | customDate: "d MMM y HH:mm" }} &
          {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else if (data?.maxDateTime) {
          less than {{ data?.maxDateTime | customDate: "d MMM y HH:mm" }}
        } @else {
          greater than {{ data?.minDateTime | customDate: "d MMM y HH:mm" }}
        }
      </div>
    }
    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Select Time"
        [(ngModel)]="data.newValue"
        (change)="changeStatusTimeStamp($event, data)"
        [min]="data?.minDateTime"
        [max]="data?.maxDateTime"
      />
      <label>Select Time</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="eventTimepStampUpdateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="eventTimepStampUpdateTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!--looped prompt template-->
<ng-template let-dataItem="value" #promptTemplate>
  @if (dataItem?.description) {
    <dl [id]="'mobile_form_summary' + dataItem?.file_id">
      @if (
        dataItem?.file_id &&
        promptFileDataUrls?.length &&
        !showDataObject.showSummaryOnly
      ) {
        <a
          class="cursor-pointer"
          (click)="
            scrollToSection($event, 'mobile_form_detail' + dataItem?.file_id)
          "
          style="color: #00538d"
        >
          <dt class="text-uppercase">{{ dataItem?.description }}</dt>
        </a>
      } @else {
        <dt class="text-uppercase">{{ dataItem?.description }}</dt>
      }
      <dd>{{ dataItem | misc: "promptValue" }}</dd>
    </dl>
  }
  @for (option of dataItem?.options; track option) {
    <div class="nested-prompt">
      <ng-template
        *ngTemplateOutlet="promptTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>

<ng-template
  #editCommentTemplate
  let-editCommentTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="editCommentTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="340"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="data.newComment"
          id="updateCommentBox"
        ></textarea>
        @if (data?.newComment) {
          <span
            class="input-group-text"
            (click)="
              clearAndFocusTextBox('updateCommentBox'); data.newComment = ''
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="editCommentTemplateRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg w-100"
            [disabled]="
              data?.previousValue === data?.newComment ||
              (data?.file_id ? false : !data?.newComment?.trim())
            "
            (click)="editCommentTemplateRef.close(data)"
            [ngClass]="data?.newComment ? 'btn-primary' : 'btn-danger'"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
